// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-1e159601]{background:linear-gradient(90deg,var(--red),orange);-webkit-background-clip:text;-webkit-text-fill-color:transparent}", ""]);
// Exports
module.exports = exports;
